export default __webpack_public_path__ + "b6828d794d763fab2aa561f28001ea3c.svg";